import { useQueryClient } from "@tanstack/react-query";
import { useInterpret } from "@xstate/react";
import Cookies from "js-cookie";
import { useRouter } from "next/router";

import orderCore from "../core/order.core";
import { PaymentSession } from "../types/pay";
import { onlineCheckoutMachine } from "./online-checkout.state";

export const useOnlineCheckoutState = () => {
  const { push, locale } = useRouter();
  const queryClient = useQueryClient();

  const checkoutStateService = useInterpret(onlineCheckoutMachine, {
    actions: {
      pushOrderCreated: (context, event) => {
        const orderId = event.data.id;
        push(`/new-order/checkout?orderId=${orderId}`);

        Cookies.remove("sessionId");
        queryClient.invalidateQueries({ queryKey: ["Cart", locale] });
      },
    },
    devTools: true,
    services: {
      assignProducts: () => push("/productImport/list"),
      createOrder: async (context) => {
        return await orderCore.createOnlineOrder(context as any);
      },
    },
  });

  return checkoutStateService;
};
